
import { ApiPaths } from "../../api/ApiPaths";
import { CareRecipientId } from "../../../domain/care_recipient/CareRecipientId";
import { UserId } from "../../../domain/user/UserId";
import { DetectionConfig } from "../../../domain/detection/config/DetectionConfig";
import { DetectionThreshold } from "../../../domain/detection/config/DetectionThreshold";
import { ApiRequest } from "../../api/ApiRequest";

export type GetDetectionConfigSuccessResponseType = {
    config: {
        highTemperature: boolean,
        highTemperatureRecovery: boolean,
        lowTemperature: boolean,
        lowTemperatureRecovery: boolean,
        missingApplianceData: boolean,
        ignoreDuringGoingOut: boolean,
        notifyHomeApplianceUsage: boolean,
        notifyHomeApplianceNotUsage: boolean,
        notifyMonthlyReport: boolean
    }
    // API処理結果判別用：OK->undefined、NG->ErrorResponseType
    error: undefined
}

export type GetDetectionThresholdSuccessResponseType = {
    threshold: {
        highTemperature: {
            wbgt: number
        },
        lowTemperature: {
            degC: number
        }
    },
    // API処理結果判別用：OK->undefined、NG->ErrorResponseType
    error: undefined
}

export async function getDetectionConfig(
    userId: UserId,
    careRecipientId: CareRecipientId
): Promise<GetDetectionConfigSuccessResponseType> {
    return await ApiRequest.get(
        ApiPaths.detection.config,
        {
            user_id: userId.value,
            care_recipient_id: careRecipientId.value
        },
        () => {},
        () => {});
}

export async function getDetectionThreshold(
    userId: UserId,
    careRecipientId: CareRecipientId
): Promise<GetDetectionThresholdSuccessResponseType> {
    return await ApiRequest.get(
        ApiPaths.detection.threshold,
        {
            user_id: userId.value,
            care_recipient_id: careRecipientId.value
        },
        () => {},
        () => {});
}

export async function updateDetectionConfig(
    userId: UserId,
    careRecipientId: CareRecipientId,
    config: DetectionConfig
) {
    const body = {
        config: config
    };

    return await ApiRequest.post(
        ApiPaths.detection.config,
        {
            user_id: userId.value,
            care_recipient_id: careRecipientId.value
        },
        body,
        () => {},
        () => {});
}

export async function updateDetectionThreshold(
    userId: UserId,
    careRecipientId: CareRecipientId,
    threshold: DetectionThreshold
) {
    const body = {
        threshold: {
            highTemperature: {
                wbgt: threshold.highTemperature.wbgt.value
            },
            lowTemperature: {
                degC: threshold.lowTemperature.temperature.value
            }
        }
    };

    return await ApiRequest.post(
        ApiPaths.detection.threshold,
        {
            user_id: userId.value,
            care_recipient_id: careRecipientId.value
        },
        body,
        () => {},
        () => {});
}
